import { db } from '@/db';
import Dexie, { Table, liveQuery } from 'dexie';
import { AppStates } from './AppStates';


export interface IAppUsers {
  id?: number;
  name: string;
  password: string;
  sysId: string;
  dataBackend: string;
}

export class AppUsers implements IAppUsers {
  appusers!: Dexie.Table<IAppUsers, number>;
  id!: number;
  name: string;
  password: string;
  sysId: string;
  dataBackend: string;

  constructor(name: string, password: string, sysId: string, dataBackend: string, id?:number) {
      this.name = name;
      this.password = password;
      this.sysId = sysId;
      this.dataBackend = dataBackend;
      if (id) this.id = id;
  }



  static async getUserToSysIdElseInsert(name: string, password: string, dataBackend: string, sysId: string){
      /* @ts-ignore */
    const res = await db.appusers.where("sysId").equals(sysId).toArray(function (appusers){
        if(appusers.length == 0){
          ///console.log('add');
          return AppUsers.addUser(name, password, dataBackend, sysId);
        }else{
          //console.log('select');
          return appusers[0];
        }
    });
  }

  static async createHash(toString: string){
    //return toString; //activate this for local testing, when it is http and not https 
    return await getSHA256Hash(toString.trim());
  }

  static addUser(name: string, password: string, dataBackend: string, sysId: string){
    return AppUsers.createHash(password).then((hashed) =>
      db.appusers.add({
        name: name.trim(),
        password: hashed,
        sysId: sysId.trim(),
        dataBackend: dataBackend.trim(),
      })
    );
  }

  static async updateDataBackend(backend: string,other: string){
    return await AppUsers.getMyUser().then((user) => {
      let namings = AppUsers.getBackendVariants();
      
      if((backend != namings.no )
        &&(backend != namings.emmie )){
      if(other.trim() == ''){
        return 'missingother'
      }
          backend = other;
      }
      db.appusers.update(user.id, {dataBackend: backend.trim()})
    })
  }

  static hasBackend(User:any){
    if(typeof User.dataBackend == 'undefined')return false;
    let namings = AppUsers.getBackendVariants();
    if((User.dataBackend == namings.no) || (User.dataBackend == ''))return false;

    return true;
  }

  static async getUserBackendVals(){
    return await AppUsers.getMyUser().then((user) => {
               
      if(typeof user.dataBackend == 'undefined'){
        user.dataBackend = '';
      }

      let namings = AppUsers.getBackendVariants();
      let backupUserOther = '';

      backupUserOther = ''
      if((user.dataBackend == namings.no)||(user.dataBackend == '')){
        user.dataBackend = namings.no

      }
      if((user.dataBackend != namings.no )
        &&(user.dataBackend != namings.emmie )){
          backupUserOther = user.dataBackend
          user.dataBackend = namings.other 
      }
      let res =  {backupUserSelected:user.dataBackend,backupUserOther:backupUserOther};
      //console.log(res)
      return res;
    })
  }

  static getBackendVariants(){
    return {no:'kein Cloud Backup',emmie:'emmie Backend',other:'andere'}
  }

  static async getMyUser(){
    return await AppStates.getMyUserLive().then((stateUser) => {
      if(typeof stateUser != 'undefined'){
        /* @ts-ignore */
        return new AppUsers(stateUser.name,stateUser.password,stateUser.sysId,stateUser.dataBackend,stateUser.id);
      }else{
        return new AppUsers('','','','',0);
      }
    }
      
    );
    //console.log(Object.keys(stateUser))
    /* @ts-ignore */
    
    //return stateUser;
  }

}

const getSHA256Hash = async (input: string) => {
    const textAsBuffer = new TextEncoder().encode(input);
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", textAsBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hash = hashArray
      .map((item) => item.toString(16).padStart(2, "0"))
      .join("");
    return hash;
  };
